import {
  addAttachmentAction,
  addCardAction,
  addCardMemberAction,
  addChecklistAction,
  addChecklistItemAction,
  addCommentAction,
  addListAction,
  copyCardAction,
  copyListAction,
  createLabelAction,
  deleteAttachmentAction,
  deleteCardAction,
  deleteChecklistAction,
  deleteChecklistItemAction,
  deleteCommentAction,
  deleteLabelAction,
  deleteListAction,
  joinCardAction,
  leaveCardAction,
  moveCardAction,
  moveListAction,
  removeBoardMemberAction,
  removeCardMemberAction,
  updateBoardAction,
  updateBoardMemberRoleAction,
  updateCardAction,
  updateChecklistItemAction,
  updateCommentAction,
  updateLabelAction,
  updateListAction,
} from '../slices/board/thunks';

export const BOARD_REALTIME_ACTIONS = {
  UPDATE_BOARD: updateBoardAction.fulfilled.type,
  ADD_LIST: addListAction.fulfilled.type,
  COPY_LIST: copyListAction.fulfilled.type,
  UPDATE_LIST: updateListAction.fulfilled.type,
  MOVE_LIST: moveListAction.fulfilled.type,
  DELETE_LIST: deleteListAction.fulfilled.type,
  ADD_CARD: addCardAction.fulfilled.type,
  UPDATE_CARD: updateCardAction.fulfilled.type,
  DELETE_CARD: deleteCardAction.fulfilled.type,
  MOVE_CARD: moveCardAction.fulfilled.type,
  COPY_CARD: copyCardAction.fulfilled.type,
  JOIN_CARD: joinCardAction.fulfilled.type,
  LEAVE_CARD: leaveCardAction.fulfilled.type,
  REMOVE_CARD_MEMBER: removeCardMemberAction.fulfilled.type,
  CREATE_LABEL: createLabelAction.fulfilled.type,
  UPDATE_LABEL: updateLabelAction.fulfilled.type,
  DELETE_LABEL: deleteLabelAction.fulfilled.type,
  ADD_CHECKLIST_ITEM: addChecklistItemAction.fulfilled.type,
  UPDATE_CHECKLIST_ITEM: updateChecklistItemAction.fulfilled.type,
  DELETE_CHECKLIST_ITEM: deleteChecklistItemAction.fulfilled.type,
  ADD_CHECKLIST: addChecklistAction.fulfilled.type,
  DELETE_CHECKLIST: deleteChecklistAction.fulfilled.type,
  ADD_COMMENT: addCommentAction.fulfilled.type,
  UPDATE_COMMENT: updateCommentAction.fulfilled.type,
  DELETE_COMMENT: deleteCommentAction.fulfilled.type,
  ADD_CARD_MEMBER: addCardMemberAction.fulfilled.type,
  ADD_ATTACHMENT: addAttachmentAction.fulfilled.type,
  DELETE_ATTACHMENT: deleteAttachmentAction.fulfilled.type,
  REMOVE_MEMBER: removeBoardMemberAction.fulfilled.type,
  UPDATE_MEMBER_ROLE: updateBoardMemberRoleAction.fulfilled.type,
} as const;

export type BoardRealtimeActionType =
  (typeof BOARD_REALTIME_ACTIONS)[keyof typeof BOARD_REALTIME_ACTIONS];

export const BOARD_REALTIME_BROADCAST_ACTIONS = new Set<string>(
  Object.values(BOARD_REALTIME_ACTIONS)
);
